import { render } from "./SkippedVerses.vue?vue&type=template&id=717cab96&ts=true"
import script from "./SkippedVerses.vue?vue&type=script&lang=ts"
export * from "./SkippedVerses.vue?vue&type=script&lang=ts"

import "./SkippedVerses.vue?vue&type=style&index=0&id=717cab96&lang=scss"

import exportComponent from "/home/node/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__